<script setup lang="ts">
import { UiSkeleton } from "@packages/component-library";
import { computed } from "vue";
import { useLandingStore } from "@/modules/landing-module";
import { IconImageFill } from "@packages/icon-library";

const landingStore = useLandingStore();
const offersCategories = computed(() => landingStore.offersCategories);
</script>

<template>
  <section class="landing-banner__categories">
    <template v-if="offersCategories.length">
      <div class="categories-slider">
        <RouterLink
          v-for="(category, index) in offersCategories"
          :key="index"
          :to="{ name: 'OffersCategoryView', params: { id: category.id } }"
        >
          <span
            :style="{
              backgroundImage: category.image_src
                ? `url(${category.image_src})`
                : '',
            }"
          >
            <IconImageFill v-if="!category.image_src" />
          </span>

          {{ category.title }}
        </RouterLink>
      </div>
      <div class="categories-slider" aria-hidden="true">
        <RouterLink
          v-for="(category, index) in offersCategories"
          :key="index"
          :to="{ name: 'OffersCategoryView', params: { id: category.id } }"
        >
          <span
            :style="{
              backgroundImage: category.image_src
                ? `url(${category.image_src})`
                : '',
            }"
          >
            <IconImageFill v-if="!category.image_src" />
          </span>

          {{ category.title }}
        </RouterLink>
      </div>
    </template>

    <template v-else>
      <UiSkeleton v-for="item in 7" :key="item" type="card" />
    </template>
  </section>
</template>

<style scoped lang="scss">
.landing-banner__categories {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: calc($base-space * 4);
  @include hideScroll();
  overflow: hidden;
  position: relative;

  > .ui-skeleton {
    width: 100px;
    height: 100px;
  }
}

.categories-slider {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  gap: calc($base-space * 6);
  counter-reset: item;
  justify-content: space-around;
  min-width: 100%;
  animation: scroll 60s linear infinite;

  > a {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    width: 100px;
    gap: calc($base-space * 4);
    @include body-s();
    color: var(--color-semantic-content-normal-primary);
    text-align: center;

    > span {
      width: 100px;
      height: 100px;
      border-radius: 16px;
      @include centerBackgroundImageContain();
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--color-semantic-background-normal-secondary);

      > .icon {
        background-color: var(
          --color-semantic-content-normal-contrast-secondary
        );
      }
    }
  }
}

@keyframes scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(calc(-100% - 16px));
  }
}
</style>
